<script setup lang="ts">
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import { useStore } from "@/store";
    import { flashWarning } from "@/utils";

    withDefaults(defineProps<{ label?: string }>(), { label: "Underlag" });

    const fetchUnderlag = async ({ query }: { query?: string } = {}) => {
        const store = useStore();
        try {
            const params: { namn?: string } = {};
            if (query) params.namn = query;

            const { subsetName } = await store.dispatch("skreg/underlag/fetchUnderlag", { filterParams: params });
            const items = store.getters["skreg/underlag/underlagSubset"]({ subsetName, limit: 0 });

            return items.map((underlag: { id: string; namn: string }) => ({
                value: underlag.id,
                label: underlag.namn,
            }));
        } catch {
            flashWarning("Kunde inte hämta underlag");
        }
    };
</script>

<template>
    <KAutocomplete
        name="underlag"
        :label="label"
        v-bind="$attrs"
        :options="fetchUnderlag"
        :onSearch="fetchUnderlag"
        :converter="defaultAutocompleteConverter"
    />
</template>

<style lang="scss" scoped></style>
